import { NgModule } from '@angular/core';

//Modules
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../material.module';

//Components
//App
import { AppLogo } from './logo';
import { AppLoadbar } from './loadbar';
import { AppPaginator } from './paginator/paginator';
//Dialogs
import { AppDialog } from './dialog/app.dialog';
import { IframeDialog } from './dialog/iframe.dialog';
import { GalleryDialog } from './dialog/gallery.dialog';
import { GoogleMapsModule } from '@angular/google-maps';
import { JsonDialog } from './dialog/json.dialog';
//Misc
import { MapPin } from './map-pin';
import { VideoMarketingLink } from './video-marketing/video-marketing-link';

@NgModule({
  imports: [ //Modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    GoogleMapsModule
  ],
  declarations: [ //Components
    //App
    AppLogo,
    AppLoadbar,
    AppPaginator,
    //Dialogs
    AppDialog,
    IframeDialog,
    GalleryDialog,
    JsonDialog,
    //Misc
    MapPin,
    VideoMarketingLink
  ],
  exports: [ //Exported Components
    //Module
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    //App
    AppLogo,
    AppLoadbar,
    AppPaginator,
    //Misc
    MapPin,
    VideoMarketingLink
  ]
})
export class SharedModule { }
